import {Portal} from '../../core';
import {AnimationState, SlideFade} from '../../transition';
import {useCallback, useId, useMemo, useState} from 'react';
import Selectors from '../snackbar.selectors';
import {HPosition, VPosition} from '../types';
import {PositionProperties} from './types';
import {getPositionProperties} from './utils';
import styles from '../layout/layout.module.less';

interface Props {
	vPos: VPosition | number;
	hPos: HPosition | number;
	show: boolean;
	animationDuration: number;
	onExit: () => void;
	message: any;
}


export function SnackbarMessage(props: Props) {
	const id = useId();
	const [position, setPosition] = useState<{top: number, left: number}>();

	const anchorStyles = useMemo<PositionProperties>(() => getPositionProperties(props.vPos, props.hPos), [props.vPos, props.hPos]);

	const onStateChanged = useCallback((state: AnimationState) => state === 'exit' && props.onExit(), [props.onExit]);

	const onAnchorRendered = useCallback((ref: HTMLDivElement) => {
		if(ref) {
			const {top, left} = ref.getBoundingClientRect();
			setPosition({top, left});
		}
	}, []);

	return <>
		<div ref={onAnchorRendered} className={styles.anchor} style={anchorStyles}/>
		{position && <Portal owner={document.body}>
			<SlideFade key={id}
			           axis='y'
			           from='negative'
			           animateOnMount
			           in={props.show}
			           distance={50}
			           duration={props.animationDuration}
			           onStateChanged={onStateChanged}>
				<div className={styles.snackbarMessage} style={position} data-cy={Selectors.message}>
					<div className={styles.snackbarContent}>{props.message}</div>
				</div>
			</SlideFade>
		</Portal>}
	</>;
}
